/** @format */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, of } from 'rxjs';
import { switchMap, take, map, first } from 'rxjs/operators';
import { DbService } from './db.service';
import { AlertService } from './alert.service';
import 'firebase/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user$: Observable<any>;
  usertmp$: Observable<any>;
  currentUid;
  constructor(
    public afAuth: AngularFireAuth,
    public db: DbService,
    public router: Router,
    public alertService: AlertService
  ) {
    this.user$ = this.afAuth.authState.pipe(
      switchMap(user => (user ? db.doc$(`users/${user.uid}`) : of(null)))
    );

    this.afAuth.authState.subscribe(data => {
      if (data) {
        localStorage.setItem('userId', data.uid);
      }
    });
  }

  getUser(): Promise<any> {
    return this.user$.pipe(first()).toPromise();
  }

  uid() {
    return this.afAuth.authState
      .pipe(
        take(1),
        map(u => u && u.uid)
      )
      .toPromise();
  }

  registerUser(email, password) {
    return new Promise<any>((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(res => {
          localStorage.setItem('userId', res.user.uid);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  loginUser(email, password) {
    return new Promise<any>((resolve, reject) => {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(
          res => resolve(res),
          err => reject(err)
        )
        .catch(err => reject(err));
    });
  }

  logoutUser() {
    return new Promise((resolve, reject) => {
      if (firebase.auth().currentUser) {
        firebase
          .auth()
          .signOut()
          .then(res => {
            localStorage.clear();
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  }

  exitUser() {
    return new Promise((resolve, reject) => {
      const user = firebase.auth().currentUser;
      this.db
        .updateAt(`users/${user.uid}`, { exitSwitch: true })
        .then(() => {
          user
            .delete()
            .then(result => {
              localStorage.clear();
              this.router.navigateByUrl('/');
              resolve(true);
            })
            .catch(error => {
              reject(error);
              console.log('error', error);
            });
        })
        .catch(error => {
          console.log('error', error);
          reject(error);
        });
    });
  }

  sendPasswordReset(email) {
    return new Promise(resulve => {
      firebase
        .auth()
        .sendPasswordResetEmail(email)
        .then(success => {
          resulve(success);
          console.log('success', success);
        })
        .catch(error => {
          let code = error['code'];
          this.alertService.showErrorMessage(code);
        });
    });
  }

  changePassword(pwd) {
    return new Promise((resulve, reject) => {
      this.afAuth.currentUser
        .then(user => {
          user
            .updatePassword(pwd)
            .then(e => {
              resulve(e);
            })
            .catch(err => {
              reject(err);
            });
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async registerWithemailVerfy(email, password, obj) {
    try {
      var r = await this.afAuth.createUserWithEmailAndPassword(email, password);

      if (r) {
        localStorage.setItem('userId', r.user.uid);
        return this.updateMasterData(r.user.uid, obj);
      }
    } catch (error) {
      let code = error['code'];
      this.alertService.showErrorMessage(code);
      console.error(error);
    }
  }

  async updateMasterData(uid, obj?) {
    obj.uid = uid;
    const path = `master/masterInfo`;
    const data = Object.assign(
      {
        uid,
      },
      obj
    );

    await this.db
      .updateAt(path, { master: firebase.firestore.FieldValue.arrayUnion(data) })
      .then(s => {})
      .catch(e => {});

    return this.veryfiEmaill();
  }

  async veryfiEmaill(type?) {
    await (await this.afAuth.currentUser).sendEmailVerification();
    await this.afAuth.signOut();

    if (type) {
    } else {
      this.alertService
        .successmsg('회원가입', '승인 이메일이 전송되었습니다. 이메일 승인 후 재 로그인 해주세요.')
        .then(() => {
          this.router.navigateByUrl('/');
        });
    }
  }

  generateFilename() {
    var length = 20;
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
}
